var map = {
	"./": 70927,
	"./App": 9555,
	"./App.css": 10417,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Pages/About us/About us": 81557,
	"./Pages/About us/About us Style.module.css": 84024,
	"./Pages/About us/About us.jsx": 81557,
	"./Pages/Authorization/Auth": 23929,
	"./Pages/Authorization/Auth.jsx": 23929,
	"./Pages/Authorization/Auth.module.css": 10430,
	"./Pages/Registration/Registration": 18012,
	"./Pages/Registration/Registration.jsx": 18012,
	"./Pages/Registration/registration.module.css": 52399,
	"./Pages/Restore_Page/Restore.module.css": 12213,
	"./Pages/Restore_Page/RestoreAccess": 2459,
	"./Pages/Restore_Page/RestoreAccess.jsx": 2459,
	"./Pages/Restore_Page/RestorePassword": 49366,
	"./Pages/Restore_Page/RestorePassword.jsx": 49366,
	"./Pages/User_profile/Profile": 11798,
	"./Pages/User_profile/Profile.jsx": 11798,
	"./Pages/User_profile/Profile_style.module.css": 87439,
	"./Pages/User_profile/Test/Test.css": 26123,
	"./Pages/User_profile/Test/Test_Page": 1571,
	"./Pages/User_profile/Test/Test_Page.jsx": 1571,
	"./Pages/User_profile/Test/newStyleLog/NewLogin": 31044,
	"./Pages/User_profile/Test/newStyleLog/NewLogin.jsx": 31044,
	"./Pages/User_profile/Test/newStyleLog/new.module.css": 74393,
	"./Pages/Users_guide/Tabs": 38271,
	"./Pages/Users_guide/Tabs.css": 11562,
	"./Pages/Users_guide/Tabs.jsx": 38271,
	"./Pages/Users_guide/User_manual": 64754,
	"./Pages/Users_guide/User_manual.jsx": 64754,
	"./Pages/Users_guide/User_manual.module.css": 90375,
	"./Pages/background-space.css": 23072,
	"./components/Header/AccountMenu/AccountMenu": 26552,
	"./components/Header/AccountMenu/AccountMenu.css": 91645,
	"./components/Header/AccountMenu/AccountMenu.js": 26552,
	"./components/Header/Header": 11676,
	"./components/Header/Header.css": 48697,
	"./components/Header/Header.js": 11676,
	"./components/Header/MainMenu/MainMenu": 84301,
	"./components/Header/MainMenu/MainMenu.css": 17058,
	"./components/Header/MainMenu/MainMenu.js": 84301,
	"./components/Info/Coordiantes.css": 50913,
	"./components/Info/Coordinates": 93085,
	"./components/Info/Coordinates.jsx": 93085,
	"./components/Info/custom.geo": 57919,
	"./components/Info/custom.geo.json": 57919,
	"./components/Info/national-parks": 66752,
	"./components/Info/national-parks.json": 66752,
	"./components/MainNavBar/MainNavBar": 3609,
	"./components/MainNavBar/MainNavBar.jsx": 3609,
	"./components/MainNavBar/MainNavBar.module.css": 69703,
	"./components/MainNavBar/reportModal/ModalPDF": 98392,
	"./components/MainNavBar/reportModal/ModalPDF.jsx": 98392,
	"./components/MainNavBar/reportModal/ModalSHP": 20591,
	"./components/MainNavBar/reportModal/ModalSHP.jsx": 20591,
	"./components/MainNavBar/reportModal/SetModalTimeDecorator": 524,
	"./components/MainNavBar/reportModal/SetModalTimeDecorator.js": 524,
	"./components/MainNavBar/reportModal/modalStyle.module.css": 67582,
	"./components/Map/Context": 51808,
	"./components/Map/Context.jsx": 51808,
	"./components/Map/Map": 13372,
	"./components/Map/Map.css": 5323,
	"./components/Map/Map.jsx": 13372,
	"./components/Map/MapEvents/MapEvents": 66848,
	"./components/Map/MapEvents/MapEvents.js": 66848,
	"./components/Map/Mark_render.module.css": 54997,
	"./components/Map/MarkersLayer/markersLayer": 4230,
	"./components/Map/MarkersLayer/markersLayer.jsx": 4230,
	"./components/Map/MutableImageOverlay": 98019,
	"./components/Map/MutableImageOverlay.jsx": 98019,
	"./components/Map/PointsRequest/PointsRequest": 12516,
	"./components/Map/PointsRequest/PointsRequest.jsx": 12516,
	"./components/Map/RequestsForImagesData/RequestForImagesData": 55788,
	"./components/Map/RequestsForImagesData/RequestForImagesData.js": 55788,
	"./components/Map/Ruler/Ruler": 64100,
	"./components/Map/Ruler/Ruler.css": 66596,
	"./components/Map/Ruler/Ruler.jsx": 64100,
	"./components/Map/Ruler/rulerControl/leaflet-ruler": 90972,
	"./components/Map/Ruler/rulerControl/leaflet-ruler.js": 90972,
	"./components/Map/layers/NatureReservesBorders": 88822,
	"./components/Map/layers/NatureReservesBorders.jsx": 88822,
	"./components/Map/layers/countryBorders": 41760,
	"./components/Map/layers/countryBorders.jsx": 41760,
	"./components/Map/layers/localities": 48921,
	"./components/Map/layers/localities.jsx": 48921,
	"./components/Map/layers/localities.module.css": 36135,
	"./components/Map/mark_render": 59998,
	"./components/Map/mark_render.jsx": 59998,
	"./components/TimeLine/Card/Card": 29345,
	"./components/TimeLine/Card/Card.jsx": 29345,
	"./components/TimeLine/Card/Card.module.css": 19258,
	"./components/TimeLine/ClocksForDate/ClocksForDate": 56262,
	"./components/TimeLine/ClocksForDate/ClocksForDate.jsx": 56262,
	"./components/TimeLine/CurrentDayDisplay/CurrentDayDisplay": 85194,
	"./components/TimeLine/CurrentDayDisplay/CurrentDayDisplay.jsx": 85194,
	"./components/TimeLine/CurrentDayDisplay/CurrentDayDisplay.module.css": 99914,
	"./components/TimeLine/RequestForDataView": 78007,
	"./components/TimeLine/RequestForDataView.js": 78007,
	"./components/TimeLine/TimeLine": 83350,
	"./components/TimeLine/TimeLine.jsx": 83350,
	"./components/TimeLine/TimeLine.module.css": 71499,
	"./components/YandexMetrica": 3020,
	"./components/YandexMetrica.js": 3020,
	"./components/buttons/materialui buttons": 58094,
	"./components/buttons/materialui buttons.js": 58094,
	"./config/config": 17406,
	"./config/config.js": 17406,
	"./data/coordinateFiles/NatureReservesCoords": 13193,
	"./data/coordinateFiles/NatureReservesCoords.json": 13193,
	"./data/coordinateFiles/countryCoords": 43801,
	"./data/coordinateFiles/countryCoords.json": 43801,
	"./data/coordinateFiles/countryCoordsNew": 78723,
	"./data/coordinateFiles/countryCoordsNew.json": 78723,
	"./data/coordinateFiles/settLements": 84566,
	"./data/coordinateFiles/settLements.js": 84566,
	"./data/coordinateFiles/settlement_out": 32613,
	"./data/coordinateFiles/settlement_out.js": 32613,
	"./data/coordinateFiles/settlement_out2": 11306,
	"./data/coordinateFiles/settlement_out2.js": 11306,
	"./data/coordinateFiles/settlement_out_3": 52564,
	"./data/coordinateFiles/settlement_out_3.js": 52564,
	"./icons/1x/outline_account_circle_black_24dp.png": 16259,
	"./icons/1x/outline_face_unlock_black_24dp.png": 15998,
	"./icons/1x/twotone_miscellaneous_services_black_24dp.png": 56436,
	"./icons/1x/twotone_notes_black_24dp.png": 15588,
	"./icons/2x/clock.png": 36311,
	"./icons/2x/outline_arrow_back_black_24dp.png": 52071,
	"./icons/2x/outline_arrow_forward_black_24dp.png": 63863,
	"./icons/2x/outline_maps_home_work_black_24dp.png": 47634,
	"./icons/2x/twotone_miscellaneous_services_black_24dp.png": 54605,
	"./icons/2x/twotone_notes_black_24dp.png": 82248,
	"./icons/NavBarIcons/1x/twotone_miscellaneous_services_black_24dp.png": 12765,
	"./icons/NavBarIcons/2x/twotone_miscellaneous_services_black_24dp.png": 4314,
	"./icons/Ruler/1x/outline_straighten_black_24dp.png": 26826,
	"./icons/cities/city.png": 99193,
	"./icons/cities/marker_for_city.drawio.png": 32105,
	"./icons/cities/marker_for_city.png": 55586,
	"./icons/cities/pngegg.png": 27567,
	"./icons/closeButton/1x/twotone_close_black_24dp.png": 52032,
	"./icons/closeButton/2x/twotone_close_black_24dp.png": 30334,
	"./icons/fire point/android-chrome-192x192.png": 88700,
	"./icons/fire point/android-chrome-512x512.png": 33599,
	"./icons/fire point/apple-touch-icon.png": 24681,
	"./icons/fire point/favicon-16x16.png": 97917,
	"./icons/fire point/favicon-32x32.png": 51551,
	"./icons/fire point/favicon.ico": 75402,
	"./icons/loading-loading-forever.gif": 89726,
	"./icons/locality/black-24dp/1x/outline_location_city_black_24dp.png": 58780,
	"./icons/locality/black-24dp/2x/outline_location_city_black_24dp.png": 90792,
	"./icons/preview.mp4": 44250,
	"./icons/timeLineButton/1x/outline_calendar_month_black_24dp.png": 3943,
	"./icons/timeLineButton/2x/outline_calendar_month_black_24dp.png": 90530,
	"./icons/для руководства/NavBar/NOAA.png": 10365,
	"./icons/для руководства/NavBar/suomi.png": 35009,
	"./icons/для руководства/NavBar/Выбор региона.png": 82727,
	"./icons/для руководства/NavBar/Границы регионов.png": 55018,
	"./icons/для руководства/NavBar/Заповедники.png": 64457,
	"./icons/для руководства/NavBar/Календарь(выбор промежутка из дат).png": 41702,
	"./icons/для руководства/NavBar/Календарь.png": 51568,
	"./icons/для руководства/NavBar/Модальные окна.png": 15848,
	"./icons/для руководства/NavBar/Населёные пункты.png": 65823,
	"./icons/для руководства/NavBar/Сбросить.png": 25408,
	"./icons/для руководства/NavBar/Сортировка(24 часа).png": 39150,
	"./icons/для руководства/NavBar/Сортировка(неделя).png": 14384,
	"./icons/для руководства/NavBar/ТВВ + карта.png": 9909,
	"./icons/для руководства/NavBar/ТВВ.png": 31502,
	"./icons/для руководства/NavBar/иконка.png": 67685,
	"./icons/для руководства/NavBar/пункты + твв.png": 46050,
	"./icons/для руководства/NavBar/развернутый NavBar.png": 82934,
	"./icons/для руководства/NavBar/сортировка(вся).png": 27855,
	"./icons/для руководства/TimeLine/второй этап.png": 49571,
	"./icons/для руководства/TimeLine/вывод дней.png": 85905,
	"./icons/для руководства/TimeLine/день выбран.png": 88354,
	"./icons/для руководства/TimeLine/иконка.png": 74899,
	"./icons/для руководства/TimeLine/первый этап.png": 52626,
	"./icons/для руководства/TimeLine/третий этап.png": 56044,
	"./icons/для руководства/Снимок экрана 2023-06-03 163438.png": 92557,
	"./icons/для руководства/левый нижний угол/Линейка.png": 10959,
	"./icons/для руководства/левый нижний угол/Модули.png": 11065,
	"./index": 70927,
	"./index.js": 70927,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;